import React from 'react'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/* Aqui se configura los puntos de navegacion que estanal lado derecho de cada seccion*/ 
const NavigationDots = ({active}) => {
  
  const handleNavClick = (e, item) => {
    e.preventDefault(); // Prevenir navegación nativa
    
    if (item === 'home') {
      // Para home, forzar scroll al inicio absoluto (pixel 0)
      console.log("🏠 Navegando a Home - scroll a pixel 0");
      
      // Scroll directo al inicio absoluto de la página
      gsap.to(window, {
        duration: 1.2,
        scrollTo: {
          y: 0, // Pixel 0 absoluto
          autoKill: false
        },
        ease: "power2.inOut",
        onComplete: () => {
          console.log("✅ Scroll a Home completado en pixel 0");
          // Refresh ScrollTrigger después del scroll
          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 100);
        }
      });
    } else {
      // Para otras secciones, usar scroll normal
      const targetElement = document.querySelector(`#${item}`);
      if (targetElement) {
        gsap.to(window, {
          duration: 1.2,
          scrollTo: {
            y: targetElement,
            autoKill: false
          },
          ease: "power2.inOut"
        });
      }
    }
  };

  return (
    <div className='app__navigation'>
        {['home', 'skills', 'work', 'experience', 'about', 'contact'].map((item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a
            href={`#${item}`}
            key={item + index}
            className='app__navigation-dot'
            style={active === item ? { backgroundColor: 'var(--secondary-color)' } : { }}
            onClick={(e) => handleNavClick(e, item)}
            data-tooltip={item}
            />        
        ))}
    </div>
  )
}

export default NavigationDots